import React, { useState, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import SubTitle from '../common/SubTitle'
import StopAddMap from './StopAddMap'
import StopAddDetails from './StopAddDetails'
import config from "../../config.json";

export default function StopsAddMain() {
    const navigate = useNavigate();
    const { stopId } = useParams();
    const path = stopId ? "stops > Update Stops" : "stops > Create Stop";

    const [routesData, setRoutesData] = useState([]);
    const [initialStopData, setInitialStopData] = useState({
        stopId: '',
        name: '',
        longitude: '',
        latitude: '',
        landmark: '',
        description: ''
    });
    const [position, setPosition] = useState({ latitude: '', longitude: '' });
    const stop_base_url = `${config.baseURL}/stop/`;
    const route_base_url = `${config.baseURL}/route/`;
    // Get organization ID from localStorage
    const [organizationId, setOrganizationId] = useState(null);
    
    // Add state for user features
    const [userFeatures, setUserFeatures] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const userState = localStorage.getItem('userState');
                const parsedUserState = JSON.parse(userState);
                if (parsedUserState?.user?.organizationId) {
                    setOrganizationId(parsedUserState.user.organizationId);
                }
                
                // Load user features from localStorage
                if (parsedUserState?.features) {
                    setUserFeatures(parsedUserState.features);
                }
                
                const [routesResponse, stopResponse] = await Promise.all([
                    axios.get(`${route_base_url}`),
                    stopId
                        ? axios.get(`${config.baseURL}/stop/id`, { params: { id: stopId } })
                        : Promise.resolve(null),
                ]);

                setRoutesData(routesResponse.data);

                if (stopResponse) {
                    const stopData = stopResponse.data;
                    setInitialStopData({
                        stopId: stopData.stopId,
                        name: stopData.name,
                        longitude: stopData.longitude,
                        latitude: stopData.latitude,
                        landmark: stopData.landmark || '',
                        description: stopData.description || ''
                    });
                    setPosition({
                        latitude: stopData.latitude,
                        longitude: stopData.longitude
                    });
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        fetchData();
    }, [stopId]);

    // Permission check function
    const hasPermission = (apiPath, action) => {
        return userFeatures.some(feature =>
            feature.api_path === apiPath && feature.action === action
        );
    };

    // Check for stop schedules permission
    const canViewStopSchedules = hasPermission('/api/schedule/stop', 'POST');

    // Handle position change from map
    const handlePositionChange = (lat, lng) => {
        setPosition({
            latitude: lat.toFixed(6),
            longitude: lng.toFixed(6)
        });
    };

    // Handle position change from form input
    const updateMapPosition = (lat, lng) => {
        setPosition({
            latitude: lat,
            longitude: lng
        });
    };

    const handleSubmit = async (stopDetails) => {
        try {
            const stopData = {
                ...stopDetails,
                organizationId: organizationId,
                longitude: position.longitude,
                latitude: position.latitude
            };

            if (stopId) {
                await axios.put(`${stop_base_url}`, { ...stopData, id: stopId });
            } else {
                const resp = await axios.post(`${stop_base_url}`, stopData, {
                    withCredentials: true,
                });
                console.log("response", resp.data);
            }

            navigate("/stop"); // Redirect to stops list page
        } catch (error) {
            console.error("Error saving stop:", error);
            // Handle error (show message to user)
        }
    };

    const handleStopSchedules = () => {
        // Pass the stopId to the StopSchedule component
        navigate("/Stops/Schedule/Details", {
            state: { id: stopId }
        });
    };

    return (
        <>
            <SubTitle
                title="stops"
                path={path}
                {...(stopId && canViewStopSchedules
                    ? {
                        track: "stopSchedules",
                        trackPath: "/stop/stopschedules",
                        onTrackClick: handleStopSchedules
                    }
                    : {})}
            />
            <StopAddMap
                initialLatitude={position.latitude}
                initialLongitude={position.longitude}
                onPositionChange={handlePositionChange}
            />
            <StopAddDetails
                initialData={initialStopData}
                onSubmit={handleSubmit}
                onPositionChange={position}
                updateMapPosition={updateMapPosition}
            />
        </>
    )
}